<template>
  <div class="e-card" v-if="isLoaded"> 
    <div class="e-card-title"> Update System Outage</div>
    <div class="e-card-content">
        <div class="form-row card-row">
          <ejs-richtexteditor 
            ref="outageRTE" 
            :height="180" 
            v-model="outageMessage"
            :fontFamily="fontFamily"
            :toolbarSettings="toolbarSettings"
          >
          </ejs-richtexteditor>
        </div>
        <div class="form-row card-row">
          <div class="cell-wrapper">
            <ejs-datetimepicker :placeholder="fromDateWaterMark" v-model="outageFromDateTime"></ejs-datetimepicker>
          </div>
          <div class="cell-wrapper">
            <ejs-datetimepicker :placeholder="toDateWaterMark" v-model="outageEndDateTime"></ejs-datetimepicker>
          </div>
        </div>
    </div>
    <div class="card-row" >
      <div class="btnContainer">
        <ejs-button type="button" @click.native="onSubmitButtonClick"
                    cssClass="e-info margin-button">Submit</ejs-button>
        <ejs-button style="margin-left:8px;" @click.native="onCancelButtonClick"
                    cssClass="e-danger margin-button">Cancel</ejs-button>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import {
  RichTextEditorPlugin,
  Toolbar,
  Link,
  Count,
  Image,
  HtmlEditor,
  QuickToolbar,
} from '@syncfusion/ej2-vue-richtexteditor';
import { DateTimePickerPlugin } from '@syncfusion/ej2-vue-calendars';
import { CheckBoxPlugin } from "@syncfusion/ej2-vue-buttons";
import { enableRipple } from '@syncfusion/ej2-base';

import { mapGetters } from "vuex";
import { FETCH_OUTAGE, PUT_OUTAGE } from "../store";

enableRipple(true);
Vue.use(RichTextEditorPlugin);
Vue.use(DateTimePickerPlugin);
Vue.use(CheckBoxPlugin);

export default {
  name: "SystemOutage",
  data() {
    return {
      isAdmin: false,
      isLoaded: false,
      fromDateWaterMark : 'Select From Date Time',
      toDateWaterMark : 'Select To Date Time',
      fontFamily: {
         default:"Segoe UI", // to define default font-family
        items:[
          {text: "Segoe UI", value: "Segoe UI", class: "e-segoe-ui",  command: "Font", subCommand: "FontName"},
          {text: "Calibri", value: "Calibri",  command: "Font", subCommand: "FontName"},
          {text: "Impact", value: "Impact,Charcoal,sans-serif", class: "e-impact", command: "Font", subCommand: "FontName"},
          {text: "Sans-Serif", value: "sans-serif", class: "e-sans-serif", command: "Font", subCommand: "FontName"},
        ]
      },
      toolbarSettings: {
        type: 'Expand',
        items: ['Bold', 'Italic', 'Underline', 'StrikeThrough',
          'FontName', 'FontSize', 'FontColor', 'BackgroundColor', '|',
          'Formats', 'Alignments', 'OrderedList', 'UnorderedList', '|',
          'CreateLink', 'Image', '|', 
          'Undo', 'Redo'
        ]
      },
      outageSetting: null,
      outageMessage: '',
      outageFromDateTime: null,
      outageEndDateTime: null,
    };
  },
  computed: {
    ...mapGetters({
      loggedUser: "loggedUser"
    }),
  },
  async created() {
    // console.log('created::this.loggedUser', this.loggedUser)
    const roles = this.loggedUser.roles.map(r => r.roleName) || [];
    this.isAdmin = roles.includes("Admin") || roles.includes("SuperAdmin");
    this.outageSetting = await this.$store.dispatch(FETCH_OUTAGE);
    this.outageMessage = this.outageSetting.message;
    this.outageFromDateTime = this.outageSetting.fromDateTime;
    this.outageEndDateTime = this.outageSetting.endDateTime;
    // console.log('outageSetting', this.outageSetting);
    this.isLoaded = true;
  },

  methods: {
    async onSubmitButtonClick() {
      this.outageSetting.message = this.outageMessage;
      this.outageSetting.fromDateTime = this.outageFromDateTime;
      this.outageSetting.endDateTime = this.outageEndDateTime;
      this.outageSetting.insertDate = new Date();
      this.outageSetting.insertUser = this.loggedUser.email;
      try {
        if(!this.validateData(this.outageSetting)) {
          this.$parent.$refs.notifierRef.show();
          return;
        }
        await this.$store.dispatch(PUT_OUTAGE, {data: this.outageSetting});

        this.$parent.notificationToasts.push({
          title: 'Success!',
          content: 'Outage Setting is updated.',
          cssClass: 'e-toast-success',
          timeOut: 5000,
        });
      } catch(err) {
        this.$parent.notificationToasts.push({
          title: 'Error!',
          content: err.message,
          cssClass: 'e-toast-danger',
          timeOut: 5000,
        });
      }
      this.$parent.$refs.notifierRef.show();
    },
    async onCancelButtonClick() {
      this.outageSetting = await this.$store.dispatch(FETCH_OUTAGE);
      this.outageMessage = this.outageSetting.message;
      this.outageFromDateTime = this.outageSetting.fromDateTime;
      this.outageEndDateTime = this.outageSetting.endDateTime;
    },
    validateData(outageSetting) {
      if(outageSetting.fromDateTime >= outageSetting.endDateTime) {
        this.$parent.notificationToasts.push({
          title: 'Error!',
          content: 'Outage Start Date and Time should be greater than Outage End Date Time',
          cssClass: 'e-toast-danger',
          timeOut: 5000,
        });
        return false
      }
      return true;
    }
  },
  provide: {
      richtexteditor:[Toolbar, Link, Image, Count, HtmlEditor, QuickToolbar]
  },
};
</script>

<style>
@import "../../../../node_modules/@syncfusion/ej2-vue-grids/styles/material.css";
@import "../../../../node_modules/@syncfusion/ej2-base/styles/material.css";
@import "../../../../node_modules/@syncfusion/ej2-inputs/styles/material.css";
@import "../../../../node_modules/@syncfusion/ej2-lists/styles/material.css";
@import "../../../../node_modules/@syncfusion/ej2-popups/styles/material.css";
@import "../../../../node_modules/@syncfusion/ej2-buttons/styles/material.css";
@import "../../../../node_modules/@syncfusion/ej2-navigations/styles/material.css";
@import "../../../../node_modules/@syncfusion/ej2-splitbuttons/styles/material.css";
@import "../../../../node_modules/@syncfusion/ej2-vue-richtexteditor/styles/material.css";

.e-content .e-item {
  font-size: 12px;
  margin: 10px;
  text-align: justify;
}

.e-tab .e-content > .e-item.e-active.collapse {
  display: none;
}

.e-tab .e-tab-header .e-indicator.collapse {
  display: none;
}
.e-tab.e-background .e-tab-header {
  background: #0f4b90;
  border: 0;
}
.e-tab.e-background .e-tab-header .e-toolbar-item.e-active .e-tab-wrap {
  background: #0f4b90;
  border-radius: 0;
}
.e-tab.e-background .e-tab-header .e-toolbar-item .e-tab-wrap {
  background: #0f4b90 !important;
}
.e-tab.e-background .e-tab-header .e-toolbar-item.e-active .e-tab-wrap:focus {
  background: #0f4b90;
}
.btnContainer {
  width: 100%;
}
.card-row {
  margin: 12px auto;
}
.cell-wrapper {
  display: inline-block;
  max-width: 250px;
  padding: 0 8px 0 8px;
}
</style>
